<template>
    <Modal
        modal-class="erotic-modal text-center"
        modal-name="erotic-modal"
        :backdrop-close="false"
        :show-close-button="false"
        @hidden="modalEroticVisible = false"
    >
        <div class="text-center">
            <img width="230" height="180" :alt="$t('erotic.imageAlt')" class="mx-auto" src="/nuxt-assets/images/png/pilulka_ero.png" />
            <h3 class="my-3" data-cy="erotic-modal">{{ $t('erotic.taskAge') }}</h3>

            <a class="btn btn-md d-block btn-primary" href="#" @click.prevent="setCookie">{{ $t('erotic.yesAge') }}</a>
            <div class="my-2">
                <a class="text-uppercase text-dark mt-3 mt-md-0 mx-4 text-decoration-underline" href="/" @click="closeModal">
                    {{ $t('erotic.noAge') }}
                </a>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
import Modal from '~/components/Modal.vue'
import { useCookie } from '#imports'

export default {
    components: {
        Modal,
    },
    data() {
        return {
            modalEroticVisible: false,
        }
    },
    mounted() {
        if (!useCookie<number>('isAdultPopup').value) {
            useNuxtApp().$bus.$emit('showModal', 'erotic-modal')
            this.modalEroticVisible = true
        }
    },
    methods: {
        closeModal() {
            this.modalEroticVisible = false
        },
        setCookie() {
            const date = new Date()

            if (this.$i18n.locale === 'hu') {
                date.setMinutes(date.getMinutes() + 20)
            } else {
                date.setMonth(date.getMonth() + 1)
            }

            useCookie<number>('isAdultPopup', { expires: date }).value = 1

            this.modalEroticVisible = false
            useNuxtApp().$bus.$emit('hideModal')
        },
    },
}
</script>
<style lang="scss" scoped>
.erotic-modal {
    .close {
        display: none;
    }
}
</style>
